import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { StyledContainer } from '../styles';

import GeoAutocomplete from './GeoAutocomplete';
import type { GeoInputProps } from './types';
export default function GeoInput<T extends FieldValues>({
  css,
  control,
  name,
  ...props
}: GeoInputProps<T>) {
  return (
    <StyledContainer css={css}>
      <Controller<T>
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <GeoAutocomplete
              {...props}
              error={error}
              onChange={onChange}
              value={value}
            />
          );
        }}
      />
    </StyledContainer>
  );
}
